import { useEffect, useRef, useState } from 'react';

interface useOnScreenInterface {
  onChangeVisibility?: (visibility: boolean) => void;
  options?: IntersectionObserverInit;
}

export function useVisibility<T extends Element>(args?: useOnScreenInterface) {
  const ref = useRef<T>(null);
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const { current } = ref;
    let observer: IntersectionObserver;

    if (current != null) {
      observer = new IntersectionObserver(([entry]) => {
        setVisible(entry.isIntersecting);
        if (args?.onChangeVisibility) {
          args.onChangeVisibility(entry.isIntersecting);
        }
      }, args?.options);
      observer.observe(current);
    }

    return () => {
      if (current != null && observer) {
        observer.unobserve(current);
      }
    };
  }, [args, args?.options]);

  return { ref, visible };
}
